import React from "react";

import { TabTitle } from "../../../../components";
import "./WizardPageTitle.scss";

export function WizardPageTitle({ children }) {
  return <TabTitle className={"wizard-page__page-title"}>{children}</TabTitle>;
}
